import { Box } from "@mui/material";
import theme from "lib/theme";

export const ContentBox = ({ props, children }: { props?: any; children: React.ReactNode }) => (
  <Box
    sx={{
      mt: 3,
      pt: 3,
      pb: 2,
      px: 3,
      border: `1px solid ${theme.palette.divider}`,
      borderRadius: 1,
      display: "grid",
      gridTemplateColumns: "auto 1fr",
      gap: 1.5,
      [theme.breakpoints.down("sm")]: { py: 2, px: 2, gridTemplateColumns: "1fr", gap: 0 },
    }}
    {...props}
  >
    {children}
  </Box>
);
